<template>
  <div class="usuarios">
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody content" label="Usuarios">
        <el-row>
          <el-col :span="24">
            <el-input
              :placeholder="$t('Búsqueda por nombre, apellido o RUT')"
              prefix-icon="el-icon-search"
              v-model="search"
              class="search"
              size="medium"
            />
            <el-button
              size="small"
              type="primary"
              @click="newUser()"
              icon="el-icon-edit"
              class="right"
            >{{ $t('Nuevo Usuario') }}</el-button>
            <el-button
              size="small"
              class="right text-center sendEmail"
              icon="el-icon-message"
              @click="sendWelcomeEmail"
              :loading="sendingEmails"
              v-if="multipleSelection.length > 0"
            >{{ $t('Enviar email de bienvenida') }} ({{multipleSelection.length}})</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :span="24"
            element-loading-text="Cargando..."
            element-loading-background="rgba(255, 255, 255)"
            v-loading="loading"
          >
            <el-table
              row-class-name="rowClassTablaPloma"
              cell-class-name="cellClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray"
              :max-height="700"
              class="usersTable"
              :data="paginar === false ? usuarios : paginarUsuarios()"
              ref="userTable"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" align="center" width="55" />
              <el-table-column min-width="100px" prop="nombre" :label="$t('Nombre')" sortable />
              <el-table-column min-width="100px" prop="apellido" :label="$t('Apellido')" sortable />
              <el-table-column prop="rut" width="250px" :label="$t('RUT')" sortable />
              <el-table-column
                prop="email"
                min-width="120px"
                :label="$t('Correo electrónico')"
                sortable
              />
              <el-table-column width="180" :label="$t('Administrador')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.roles.admin" class="tagSuperadmin">Super Administrador</div>
                  <span v-else>N/A</span>
                </template>
              </el-table-column>
              <el-table-column width="130" align="center">
                <template slot-scope="scope">
                  <div class="ver" @click="showUser(scope.row)">
                    <i class="el-icon-edit-outline"></i>
                    {{ $t('Ver / Editar') }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <br />
            <br />
            <center>
              <el-pagination
                :current-page="page"
                @prev-click="backPage"
                @next-click="nextPage"
                @current-change="currentPage"
                :page-size="6"
                layout="prev, pager, next"
                :total="totalPage"
              ></el-pagination>
            </center>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <DialogAddUser
      :user="user"
      :visibleSync="dialogUser"
      :action="action"
      :findUser="findUser"
      :onCancel="cleanUser"
      :onAcept="createUpdateUser"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";
import DialogAddUser from "@/components/dialogAddUser.vue";

const SERVICE_EMAIL_URL = "/usuarios/mailing/bienvenida";

export default {
  name: "Usuarios",
  data() {
    return {
      loading: false,
      page: 1,
      totalPage: 0,
      findUser: false,
      usuarios: [],
      dialogUser: false,
      activeName: "area-roles",
      user: {},
      action: "update",
      sendingEmails: false,
      multipleSelection: [],
      search: "",
      paginar: false
    };
  },
  async created() {
    this.setTitle("Administración de Usuarios");
    this.getAreasFaena();
    this.getEmpresasFaena();
    this.listadoUsuarios(1, this.search);
  },
  components: {
    DialogAddUser
  },
  watch: {
    "user.rut": function() {
      this.debounceInput();
    },
    search: function() {
      this.loading = true;
      this.debounceInputSearch();
    }
  },
  methods: {
    ...mapActions(["setTitle", "getEmpresasFaena", "getAreasFaena"]),
    currentPage(page) {
      this.page = page;
      this.listadoUsuarios(page, this.search);
    },
    nextPage(page) {
      this.page = page;
      this.listadoUsuarios(page, this.search);
    },
    backPage(page) {
      this.page = page;
      this.listadoUsuarios(page, this.search);
    },
    debounceInput: _.debounce(function() {
      if (Object.keys(this.user).length > 0 && this.user.rut !== "") {
        this.findUser = true;
        const userExist = this.$store.getters.usersFaena.find(
          x => x.rut === this.user.rut
        );
        if (userExist) {
          this.findUser = false;
          this.action = "update";
          this.user = userExist;
          this.user = {
            _id: userExist._id,
            nombre: userExist.nombre,
            apellido: userExist.apellido,
            rut: userExist.rut,
            email: userExist.email,
            roles: userExist.roles
          };
        } else {
          axios
            .get(`/usuarios/by_rut/${this.user.rut}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
              }
            })
            .then(response => {
              if (response.data.hasOwnProperty("success")) {
                this.findUser = false;
                (this.user._id = "Create"),
                  (this.user.nombre = ""),
                  (this.user.apellido = ""),
                  (this.user.email = ""),
                  (this.user.roles = {
                    admin: false
                  }),
                  (this.action = "create");
                this.$notify.info({
                  title: "Información",
                  message: "Usuario no encontrado."
                });
              } else {
                this.findUser = false;
                this.action = "update";
                (this.user._id = response.data._id),
                  (this.user.nombre = response.data.nombre),
                  (this.user.apellido = response.data.apellido),
                  (this.user.rut = response.data.rut),
                  (this.user.email = response.data.email);
              }
            });
        }
      }
    }, 1500),
    debounceInputSearch: _.debounce(function() {
      this.page = 1;
      this.listadoUsuarios(this.page, this.search);
    }, 1200),
    listadoUsuarios(page, search) {
      this.loading = true;
      var self = this;
      axios
        .get(
          `/usuarios/getAllUsers/${this.$store.getters.role.faena_id}/${page}/${
            search === "" ? undefined : search
          }`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then(response => {
          self.usuarios = response.data.results;
          self.totalPage = response.data.total;
          self.paginar = response.data.paginar;
          self.loading = false;
        });
    },
    paginarUsuarios() {
      return this.usuarios.slice((this.page - 1) * 6, this.page * 6);
    },
    // NUEVO
    newUser() {
      // JSON.parse(JSON.stringify())
      // para evitar warning de mutación fuera del store.
      this.user = {
        _id: "",
        nombre: "",
        apellido: "",
        rut: "",
        email: "",
        roles: {
          admin: false
        }
      };
      this.action = "create";
      this.dialogUser = true;
    },
    showUser(user) {
      // JSON.parse(JSON.stringify())
      // para evitar warning de mutación fuera del store.
      this.findUser = false;
      this.user = JSON.parse(JSON.stringify(user));
      this.action = "update";
      this.dialogUser = true;
    },
    async createUpdateUser(action) {
      const auxUser = {
        user: {
          _id: this.user._id,
          nombre: this.user.nombre,
          apellido: this.user.apellido,
          rut: this.user.rut,
          email: this.user.email,
          created_by: this.$store.getters.user._id
        }
      };
      const auxRoles = {
        faenaId: this.$store.getters.role.faena_id,
        module: "inventarios",
        permissions: this.user.roles
      };
      if (action === "create") {
        await this.createUser(auxUser, auxRoles);
      } else if (action === "update") {
        await this.updateUser(auxUser, auxRoles);
      }
    },
    async createUser(userToCreate, roles) {
      const userCreated = await this.$store.dispatch(
        "createUser",
        userToCreate
      );
      if (userCreated && userCreated.success && userCreated.userId) {
        const rolesCreated = await this.$store.dispatch(
          "updateUsersRoles",
          Object.assign({}, { userId: userCreated.userId }, roles)
        );
        if (rolesCreated) {
          this.listadoUsuarios(this.page, this.search);
          this.dialogUser = false;
          this.cleanUser();
          this.$notify.success({
            title: "Éxito",
            message: "Usuario creado exitosamente"
          });
        } else {
          this.$notify.error({
            title: "Error",
            message: "No fue posible asignar roles al usuario"
          });
        }
      } else {
        this.$notify.error({
          title: "Error",
          message: "No fue posible crear el usuario"
        });
      }
    },
    async updateUser(userToUpdate, roles) {
      const userUpdated = await this.$store.dispatch(
        "updateUser",
        userToUpdate
      );
      if (userUpdated) {
        const rolesUpdated = await this.$store.dispatch(
          "updateUsersRoles",
          Object.assign({}, { userId: this.user._id }, roles)
        );
        if (rolesUpdated) {
          this.listadoUsuarios(this.page, this.search);
          this.dialogUser = false;
          this.cleanUser();
          this.$notify.success({
            title: "Éxito",
            message: "Usuario editado exitosamente"
          });
        } else {
          this.$notify.success({
            title: "Error",
            message: "No fue posible actualizar roles del usuario"
          });
        }
      } else {
        this.$notify.success({
          title: "Error",
          message: "No fue posible actualizar el usuario"
        });
      }
    },
    cleanUser() {
      this.dialogUser = false;
      this.findUser = false;
      this.user = {};
    },
    cleanAux() {
      this.auxAC = {
        title: "",
        acs: [],
        roles: {}
      };
      this.auxUserACRoles = {
        type: "bhp",
        key: "",
        roles: []
      };
    },
    // ANTIGUO
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    sendWelcomeEmail() {
      this.sendingEmails = true;
      const users = this.multipleSelection.map(user => user._id);
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      };
      axios
        .post(SERVICE_EMAIL_URL, { userIDs: users }, config)
        .then(response => {
          this.sendingEmails = false;
          this.multipleSelection = [];
          this.$refs.userTable.clearSelection();
          this.$alert(
            "Emails de bienvenida han sido enviados exitosamente.",
            "Proceso exitoso",
            {
              type: "success"
            }
          );
        })
        .catch(error => {
          this.sendingEmails = false;
          console.error(error);
          this.$alert(
            "Lo sentimos, ha surgido un error. Intente nuevamente.",
            "Atención",
            {
              type: "error"
            }
          );
        });
    }
  }
};
</script>

<style scoped>
.tagSuperadmin {
  font-size: 13px;
  border-radius: 3px;
  border: 1px solid #4f914f;
  background-color: #d3ebcd;
  color: #4f914f;
  margin: 4px auto;
  width: 130px;
}
.ver {
  cursor: pointer;
}
.sendEmail {
  width: 300px;
  margin-right: 20px;
}
.checkbox-roles {
  margin-top: 30px;
}
.usersTable {
  margin-top: 40px;
}
.dialog-title {
  line-height: 40px;
  font-size: 18px;
  color: #303133;
}
.search {
  max-width: 450px;
  float: left;
}
.content {
  min-height: 50vh;
}
</style>
